/** 与 `modules/base/layout/index.vue` 中 `.app-layout` 的 `max-width: 768px` 一致 */
export const LAYOUT_MOBILE_BREAKPOINT = 768;
